import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, AgComboBoxEditor, } from 'jk-service';
import { AgCheckBoxEditor, AgTextAreaEditor } from 'jk-service';
import { Utysb } from '../entity/Utysb-angular';


@Injectable({
  providedIn: 'root'
})
export class UtysbServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Utysb();
    this.entityType.type = EntityType.master;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      MAINTABLE: '主資料表', ITEM: '序號', TYPE: '類別', TITLE: '標題', SQLSELECT: 'SQLSelect', SQLWHERE: 'SQLWhere', PS: '備註', DISPLAY: '顯示', MAP: 'WHERE參數設定', SQLORDER: '欄位排序', SQLRETURN: 'SQLReturn', SB100: '保留1', SB101: '保留2', SB102: '保留3', SB103: '保留4', SB104: '保留5', SB105: '保留6'
    };

    this.fieldNames = 'MAINTABLE,ITEM,TYPE,TITLE,SQLSELECT,SQLWHERE,PS,DISPLAY,MAP,SQLORDER,SQLRETURN,SB100,SB101,SB102,SB103,SB104,SB105';
    this.fieldLengths = { MAINTABLE: 50, ITEM: 50, TYPE: 1, TITLE: 50, SQLSELECT: 0, SQLWHERE: 0, PS: 255, DISPLAY: 0, MAP: 0, SQLORDER: 0, SQLRETURN: 0, SB100: 0, SB101: 0, SB102: 0, SB103: 255, SB104: 255, SB105: 255 };
    this.columnDefs = [
      { field: "SQLORDER", headerName: "欄位排序", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SB105", headerName: "保留6", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "SB104", headerName: "保留5", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "SB103", headerName: "保留4", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "SB102", headerName: "保留3", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SB101", headerName: "保留2", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SB100", headerName: "保留1", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SQLRETURN", headerName: "SQLReturn", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MAINTABLE", headerName: "主資料表", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "MAP", headerName: "WHERE參數設定", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "DISPLAY", headerName: "顯示", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "PS", headerName: "備註", headerTooltip: "", width: 250, cellDataType: "text", cellRenderer: AgTextAreaEditor, },
      { field: "SQLWHERE", headerName: "SQLWhere", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "SQLSELECT", headerName: "SQLSelect", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "TITLE", headerName: "標題", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "TYPE", headerName: "類別", headerTooltip: "", width: 80, cellDataType: "text", },
      { field: "ITEM", headerName: "序號", headerTooltip: "", width: 250, cellDataType: "text", },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'UTYSB';
    this.isSys = true;
    this.sqlSelect = `SELECT UTYSB.*  FROM ##UTYSB`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY MAINTABLE+ITEM`;
    this.keyFields = ['MAINTABLE+ITEM'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['MAINTABLE', 'ITEM'];
    this.seqField = 'ITEM';
    this.seqFieldLength = 50;
  }
  override async validateItem(item: Utysb): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

override async newRecord(newItem: Utysb): Promise<Utysb> {
    await super.newRecord(newItem);
    return newItem;
  }




}

